import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "course-detail"
};
import { reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import WujieVue from 'wujie-vue3';
import { setStore, getStore, clearStore } from '@/util/store';
import topbar from './topbar';
import content from './content';
import sildeBar from './sildeBar';
import positionBar from './positionBar';
import imagePreview from './imagePreview';
/* hooks */
import useMouseWheel from './hooks/index/useMouseWheel'; // 鼠标滚轮事件
import useImagePreview from './hooks/content/useImagePreview'; // 监听图片点击
/* api */
import { getCourseDetail, getCourseAuth } from '@/api/resources';
import { getTokenUser, getAccountInfo, getUserInfo } from '@/api/user.js';
/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 工具 */
    var bus = WujieVue.bus;
    /* 组件 */
    var route = useRoute();
    var mainStyle = useMouseWheel();
    var state = reactive({
      isCourseLoad: false,
      courseData: {},
      slideShow: false,
      visable: false,
      imgIndex: 0,
      imgList: []
    });
    /* 方法 */
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _route$query, id, source, accountType, res;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _route$query = route.query, id = _route$query.id, source = _route$query.source, accountType = _route$query.accountType;
            _context.n = 1;
            return getCourseAuth(id);
          case 1:
            res = _context.v;
            if (!(res.data.code !== 0)) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            getCourseDetail(id, source).then(function (res) {
              if (res.data.code === 0) {
                state.courseData = formartData(_objectSpread(_objectSpread({}, res.data.data), {}, {
                  accountType: Number(accountType)
                }));
                state.isCourseLoad = true;
              }
            });
          case 3:
            return _context.a(2);
        }
      }, _callee);
    })));
    var formartData = function formartData(data) {
      if (data.courseItemTrees) {
        data.children = data.courseItemTrees;
        delete data.courseItemTrees;
      }
      return data;
    };
    var showChange = function showChange(isShow) {
      state.slideShow = isShow;
    };
    var contentScroll = function contentScroll(e) {
      var scrollTop = e.target.scrollTop;
      bus.$emit('course-content-scroll', scrollTop);
    };
    var imagePreviewHandle = function imagePreviewHandle(url) {
      state.visable = true;
      state.imgIndex = 0;
      state.imgList = [url];
    };
    useImagePreview(imagePreviewHandle);
    return function (_ctx, _cache) {
      return state.isCourseLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(topbar), {
        "course-data": state.courseData
      }, null, 8, ["course-data"]), _createVNode(_unref(sildeBar), {
        "course-data": state.courseData,
        onShowChange: showChange
      }, null, 8, ["course-data"]), _createVNode(_unref(positionBar), {
        "slide-show": state.slideShow,
        "course-data": state.courseData
      }, null, 8, ["slide-show", "course-data"]), _createElementVNode("div", {
        class: "main-content",
        style: _normalizeStyle(_unref(mainStyle)),
        onScroll: contentScroll
      }, [_createVNode(_unref(content), {
        "course-data": state.courseData
      }, null, 8, ["course-data"])], 36), _createVNode(_unref(imagePreview), {
        visable: state.visable,
        "onUpdate:visable": _cache[0] || (_cache[0] = function ($event) {
          return state.visable = $event;
        }),
        index: state.imgIndex,
        list: state.imgList
      }, null, 8, ["visable", "index", "list"])])) : _createCommentVNode("", true);
    };
  }
};